import { DateTime } from 'luxon';

export function estDateStringToTimeAndDateEST(dateString) {
  const dateObject = new Date(dateString);
  const dateTime = DateTime.fromJSDate(dateObject).toFormat('HH:mm MM/dd');
  return dateTime;
}
